export default "__VITE_ASSET__d2b26cab__"